import React, { ReactNode } from "react";
import styles from "./home-screen-container.module.scss";

interface HomeScreenContainerPropTypes {
  children: ReactNode;
  backgroundColor?: string;
  backgroundUrl?: string | null;
}

const cssClassName = "home-screen-container";

export const HomeScreenContainer = ({
  children,
  backgroundColor = "#152125",
  backgroundUrl,
}: HomeScreenContainerPropTypes) => {
  return (
    <div
      className={styles[cssClassName]}
      style={{
        backgroundColor: backgroundColor,
        ...(backgroundUrl ? { backgroundImage: `url(${backgroundUrl})` } : {}),
      }}
    >
      {children}
    </div>
  );
};
